/**
 * Meta Pixel（EDG-594）：Meta 广告投放追踪。
 *
 * 属于 tracking-conventions §0 的投放侧例外，口径以投放方给的为准：
 * - 只在正式环境加载（prod / oldprod），测试数据不进广告后台
 * - App 内 WebView（UA 含 `EdgenApp/`）不加载，只统计浏览器访问；App 端归 Adjust
 * - iframe 内不加载：homesite 用 iframe 预加载 / 弹出 `/login_popup`，不挡会在宿主页之外
 *   再多发一次 PageView。广告流量都是顶层打开，iframe 内的浏览对投放没有意义
 * - 事件里不带任何用户资料
 */

export const META_PIXEL_ID = "1567724896814242";

/** 对外的正式环境（prod / oldprod 同配置，同 structured-cards-demo 的 PUBLIC_ENVS）。 */
const PUBLIC_ENVS = ["prod", "oldprod"];

export function isMetaPixelEnabled(): boolean {
  return PUBLIC_ENVS.includes(process.env.NEXT_PUBLIC_ENV ?? "");
}

type Fbq = (...args: unknown[]) => void;

declare global {
  interface Window {
    fbq?: Fbq;
  }
}

/**
 * 官方 base code，外包一层 App WebView / iframe 判断。
 * 首次 PageView 由这里发；之后的站内跳转由 `MetaPixelPageView` 补发（fbq 未初始化时自动 no-op）。
 */
export const META_PIXEL_BASE_SCRIPT = `
(function(){
if (/EdgenApp\\//.test(navigator.userAgent || "")) return;
if (window.self !== window.top) return;
!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
document,'script','https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${META_PIXEL_ID}');
fbq('track', 'PageView');
})();
`;

/** base code 未加载（非正式环境 / App 内）时为 no-op；fbq 内部出错也只吞掉，不影响页面。 */
export function trackMetaPageView(): void {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.fbq?.("track", "PageView");
  } catch {
    // 广告追踪失败不影响业务
  }
}
